module.exports = __webpack_public_path__ + "img/w3.ad03d33d.jpg";